<template>

  <v-container grid-list-md>
    <h1>管理</h1>

    <h1>Document Path</h1>

    <v-layout row wrap>
      <v-flex md2>
        <v-text-field v-model="collection" />
      </v-flex>
      <v-flex md2>
        <v-text-field v-model="document" />
      </v-flex>
      <v-btn @click="addItem()">
        Add
      </v-btn>
    </v-layout>

    <v-layout row wrap>
      <table>
        <tr>
          <th>Delete</th>
          <th>Collection</th>
          <th>Docment</th>
        </tr>
        <tr v-for="(doc, i) in items" :key="i">
          <td class="delete-cell">
            <v-btn small @click="deleteItem(i)" icon>
              X
            </v-btn>
          </td>
          <td>{{doc.collection}}</td>
          <td>{{doc.document}}</td>
        </tr>
      </table>
    </v-layout>

    <v-layout row wrap>
      <v-flex md2>
        <v-btn @click="getItem()"> Get item</v-btn>
      </v-flex>
      <v-flex md6>
        <input @change="selectedFile" type="file" name="file" >
      </v-flex>
      <v-flex md2>
        <v-btn @click="setItem"> Set Item</v-btn>
      </v-flex>
    </v-layout>

    <v-textarea :value="result" readonly box>

    </v-textarea>

    <v-layout row wrap>
      <v-flex md6>
        <input @change="selectedFile" type="file" name="file">
      </v-flex>
    </v-layout>


  </v-container>
</template>

<script>
import db from '@/components/firebaseInit'
//const data = require("../data/company.json");
var moment = require('moment-timezone')
export default {
  components: {
  },
  data() {
    return {
      uploadFile: null,
      items: [],
      collection: "",
      document: "",
      result: ""
    }
  },
  created() {
  },
  computed: {
    dbRef() {
      var dbr = db
      this.items.forEach(item => {
        dbr = dbr.collection(item.collection).doc(item.document)
      })
      return dbr
    },
  },
  methods: {
    // setDbRef() {
    //   this.items.forEach(item => {
    //     this.dbRef = this.dbRef.collection(item.collection).doc(item.document)
    //   })
    // },
    setItem() {
      const data = JSON.parse(this.result)
      this.dbRef.set(data)
        .then(function (docRef) {
          console.log("Document successfully written!");
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    },
    selectedFile(e) {
      // 選択された File の情報を保存しておく
      e.preventDefault();
      let files = e.target.files;
      this.uploadFile = files[0];
      var reader = new FileReader();
      // ファイル読み取りに失敗したとき
      reader.onerror = function () {
        alert('ファイル読み取りに失敗しました')
      }
      // ファイル読み取りに成功したとき
      reader.onload = () => {
        this.result = reader.result
      }
      reader.readAsText(this.uploadFile);

    },
    addItem() {
      this.items.push({ collection: this.collection, document: this.document })
      this.collection = ""
      this.document = ""
    },
    deleteItem(index) {
      this.items.splice(index, 1)
    },
    async getItem() {
      try {
        const doc = await this.dbRef.get()
        if (doc.exists) {
          this.result = JSON.stringify(doc.data())
        } else {
          this.result = "The document doesn't exist"
        }
      } catch (e) {
        this.result = "Error:" + e
        console.error(e)
      }

    }
  }
}
</script>
<style lang="scss" scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgba(0, 0, 0, 0.12);
  table-layout: fixed;
  font-size: 9pt;
  width: 100%;
  tr,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid gray;
  }
  td {
    word-wrap: break-word;
    padding: 5pt;
  }
  tr {
    height: 10mm;
  }
  td.delete-cell {
    text-align: center;
    padding: 0px;
  }
}
</style>

